/**
 * API service for managing user favorites (signs and custom composite signs)
 */

import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

export interface UserFavorites {
  user_id: string;
  sign_codes: string[];  // Regular sign codes
  custom_sign_ids: string[];  // Custom composite sign IDs
  updated_at?: string;
}

/**
 * Get user's favorites
 */
export const getUserFavorites = async (authToken: string): Promise<UserFavorites> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/api/favorites/`, {
      headers: {
        'Authorization': `Bearer ${authToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching favorites:', error);
    // Return empty favorites on error
    return { user_id: '', sign_codes: [], custom_sign_ids: [] };
  }
};

/**
 * Toggle a regular sign in favorites
 */
export const toggleSignFavorite = async (authToken: string, signCode: string): Promise<UserFavorites> => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/favorites/toggle-sign`,
      { sign_code: signCode },
      {
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error toggling sign favorite:', error);
    throw error;
  }
};

/**
 * Toggle a custom composite sign in favorites
 */
export const toggleCustomSignFavorite = async (authToken: string, customSignId: string): Promise<UserFavorites> => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/favorites/toggle-custom-sign`,
      { custom_sign_id: customSignId },
      {
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error toggling custom sign favorite:', error);
    throw error;
  }
};

